import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { LargedTuileComponent } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';

@Component({
  selector: 'app-p00076-card-constance-statut',
  templateUrl: './p00076-card-constance-statut.component.html',
  styleUrls: ['./p00076-card-constance-statut.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe, LargedTuileComponent],
})
export class P00076CardConstanceStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: any[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P00076.card.state.off',
        statusTitle: 'P00076.card.state.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P00076.card.state.regul',
        statusTitle: 'P00076.card.state.regul',
        icon: 'fa-kit fa-picto-programme',
        color: 'color-green',
        status: 'active',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.WATER_LEVEL,
      FunctionOnglet.CONTROL,
      this.translateService.instant('dashboard.water_level'),
    );
  }
}
